// @flow
// eslint-disable-next-line no-unused-vars
import { fetch as fetchPolyfill } from 'whatwg-fetch'
import queryString from 'query-string'
import { get } from 'lodash'

// fetchPolyfill()

export default class Request {
  request(url, method, data, header) {
    const credentials = 'same-origin'
    const headers = new Headers(header)

    if (method === 'GET' || method === 'DELETE') {
      const paramKeyValuePairString = queryString.stringify(data, { arrayFormat: 'bracket' })
      if (paramKeyValuePairString.length > 0) {
        url = `${url}?${paramKeyValuePairString}`
      }
      data = null
    }

    if (
      headers.has('Content-Type') &&
      headers.get('Content-Type') === 'application/x-www-form-urlencoded;charset=utf-8'
    ) {
      const dataJSONString = queryString.stringify(data, { arrayFormat: 'bracket' })
      data = dataJSONString
    }

    // if no Content-Type , set it
    if (!headers.has('Content-Type')) {
      headers.set('Content-Type', 'application/json')
    }
    if (
      headers.get('Content-Type') === 'application/json' &&
      (method === 'PUT' || method === 'POST')
    ) {
      data = JSON.stringify(data)
    }
    const userInfo = window.store ? window.store.getState().users : {}
    if (url !== '/cow/account/sign_in' && get(userInfo, 'token')) {
      headers.set('auth-token', userInfo.token)
    }
    return fetch(url, {
      body: data, // must match 'Content-Type' header
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials, // include, same-origin, *omit
      headers,
      method, // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, cors, *same-origin
      redirect: 'follow' // manual, *follow, error
      // referrer: 'no-referrer' // *client, no-referrer
    })
  }
}
